import { FunctionalComponent, h } from "preact";
import { useEffect, useRef, useState } from "preact/hooks";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { Labels } from "../../models/labels";
import { getIsEdge } from "../../configs/env";
import SearchIcon from "../../assets/icons/SearchIcon";
import styles from "./portalSearchStyles.css";
import {
  setKapps,
  setTags,
  setExactMatch,
  setSelectedCategory,
  setSelectedFilters,
} from "../../redux/slices/searchSlice";
import { initialSelectedFilters } from "../../models/consts";
import { isMobileOnly as isMobileOnlyReact } from "react-device-detect";
import { route } from "preact-router";
interface IProps {
  workspaceId: string;
  kappId?: string;
  portalId?: string;
  workspaceAlias?: string;
  portalAlias?: string;
  isDrawerOpen?: boolean;
  showHomeButton?: boolean;
  placeHolder: string;
  value?: string;
  prevQ?: string;
  handleUpdateNestedTags?: () => void;
  handleClearNestedTags?: () => void;
  active?: string;
}
const PortalSearchField: FunctionalComponent<IProps> = (props) => {
  const {
    workspaceId,
    kappId,
    portalId,
    workspaceAlias,
    portalAlias,
    showHomeButton,
    placeHolder,
    value,
    prevQ,
    isDrawerOpen,
    handleUpdateNestedTags,
    handleClearNestedTags,
    active,
  } = props;
  const dispatch = useAppDispatch();
  const searchState = useAppSelector((state) => state.search);
  const appearance = useAppSelector((state) => state.appearance);
  const input = useRef<any>(null);
  const [showClearButton, setShowClearButton] = useState<boolean>(false);
  const [clearInputText, setClearInputText] = useState<boolean>(false);

  useEffect(() => {
    if (input?.current?.value && input.current?.value.length > 0)
      setShowClearButton(true);
  }, []);

  const goHome = async () => {
    let detail: string;
    if (active === "Smart Search") {
      if (workspaceAlias && portalAlias) {
        detail = `/${workspaceAlias}/${portalAlias}`;
      } else {
        detail =
          portalId && portalId?.length > 0
            ? `/workspace/${workspaceId}/portal/${portalId}/home`
            : `/workspace/${workspaceId}/kapp/${kappId}/home`;
      }
    } else {
      if (workspaceAlias && portalAlias) {
        detail = `/${workspaceAlias}/${portalAlias}/keywordHome`;
      } else {
        detail =
          portalId && portalId?.length > 0
            ? `/workspace/${workspaceId}/portal/${portalId}/keywordHome`
            : `/workspace/${workspaceId}/kapp/${kappId}/keywordHome`;
      }
    }
    const tempKapp = searchState.kapps.map((kapp: any) => {
      if (kapp.selected) {
        return { ...kapp, selected: false }; // Create a new object with `selected` updated
      }
      return kapp; // Return the original object if no change is needed
    });
    const tempTags = searchState.tags.map((tag: any) => {
      if (tag.selected) {
        return { ...tag, selected: false }; // Create a new object with `selected` updated
      }
      return tag; // Return the original object if no change is needed
    });
    dispatch(setKapps(tempKapp));
    dispatch(setTags(tempTags));
    dispatch(setSelectedFilters(initialSelectedFilters));
    dispatch(setExactMatch(""));
    dispatch(setSelectedCategory([]));
    (window as any).dispatchEvent(
      new CustomEvent("route-to", {
        detail,
      })
    );
  };
  const search = () => {
    if (input.current?.value?.length == 0) return;
    if (handleUpdateNestedTags) handleUpdateNestedTags();
    if (handleClearNestedTags) handleClearNestedTags();
    let detail: string;
    const encodedValue = encodeURIComponent(input.current?.value.trim() || "");
    if (workspaceAlias && portalAlias) {
      detail = `/${workspaceAlias}/${portalAlias}/search?q=${encodedValue}`;
    } else {
      detail =
        portalId && portalId?.length > 0
          ? `/workspace/${workspaceId}/portal/${portalId}/search?q=${encodedValue}`
          : `/workspace/${workspaceId}/kapp/${kappId}/search?q=${encodedValue}`;
    }
    // route(detail);]
    window.dispatchEvent(
      new CustomEvent("route-to", {
        detail,
      })
    );
  };

  const handleKeywordSearch = () => {
    if (input.current?.value?.length == 0) return;
    if (handleUpdateNestedTags) handleUpdateNestedTags();
    if (handleClearNestedTags) handleClearNestedTags();
    let detail: string;
    const encodedValue = encodeURIComponent(input.current?.value.trim() || "");
    if (workspaceAlias && portalAlias) {
      detail = `/${workspaceAlias}/${portalAlias}/keywordSearch?q=${encodedValue}`;
    } else {
      detail =
        portalId && portalId?.length > 0
          ? `/workspace/${workspaceId}/portal/${portalId}/keywordSearch?q=${encodedValue}`
          : `/workspace/${workspaceId}/kapp/${kappId}/keywordSearch?q=${encodedValue}`;
    }
    route(detail);
    console.log("Routing to:", detail);

    // window.dispatchEvent(
    //   new CustomEvent("route-to", {
    //     detail,
    //   })
    // );
  };
  const onKeyUp = (event: KeyboardEvent) => {
    if (input?.current?.value?.length > 0) {
      setClearInputText(true);
      setShowClearButton(true);
      if (event.key === "Enter" && input?.current?.value?.length >= 1) {
        if (active === "Keyword Search") handleKeywordSearch();
        else search();
      }
    } else {
      setShowClearButton(false);
      setClearInputText(true);
    }
  };

  const handleSeachClick = () => {
    if (input?.current?.value?.length > 0) {
      setClearInputText(true);
      setShowClearButton(true);
      if (input?.current?.value?.length >= 1) {
        if (active === "Keyword Search") handleKeywordSearch();
        else search();
      }
    } else {
      setShowClearButton(false);
      setClearInputText(true);
    }
  };

  const clearInput = () => {
    if (input && input.current.value) {
      input.current.value = "";
      setClearInputText(true);
      setShowClearButton(false);
    }
  };

  return (
    <div
      className={styles.wrapper}
      style={{
        width: isDrawerOpen ? "90%" : "",
        // direction: "rtl",
        direction: appearance.rtlenabled ? "rtl" : "ltr",
        position: "relative",
        top: "10%",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: `100%`,
        }}
      >
        {showHomeButton && !prevQ ? (
          <div onClick={goHome} className={styles.searchBackButton}></div>
        ) : (
          <div
            onClick={() => {
              if (active === "Keyword Search") {
                console.log("active");

                handleKeywordSearch();
              } else search();
            }}
            className={styles.searchButton}
          ></div>
        )}

        <input
          style={{
            fontSize: "16px",
            border: "none",
            width: "100%",
            color: "#7e8993",
            background: "none",
            fontWeight: "normal",
          }}
          type="search"
          id="LTRInput"
          enterkeyhint="search"
          placeholder={
            appearance.rtlenabled &&
            appearance.loaded &&
            !appearance.searchBarPlaceHolder
              ? Labels.SEARCH_HEB
              : placeHolder
          }
          ref={input}
          onKeyUp={onKeyUp}
          value={clearInputText ? input?.current?.value.trim() : value?.trim()}
        />
        {input?.current?.value?.length >= 1 ? (
          <div
            style={{ position: "static", display: "flex" }}
            className={styles.clearInput}
            onClick={() => {
              clearInput();
            }}
          >
            <img src="/assets/icons/search_clear.svg" />
          </div>
        ) : null}
        <div
          style={{
            margin: "5px",
            height: "50px",
            width: "50px",
            cursor: "pointer",
            transform: appearance.rtlenabled ? "rotate(180deg)" : "",
          }}
          onClick={handleSeachClick}
        >
          <SearchIcon flag={input?.current?.value?.length > 0 ? true : false} />
        </div>
      </div>
    </div>
  );
};

export default PortalSearchField;
